module.exports = "/static/assets/6b8d20e70e6d82fd3883f029ce336af5.png";